import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { AiFillDelete } from 'react-icons/ai';
import ViewInvoice from './ViewInvoice';
import UpdateInvoice from './UpdateInvoice/UpdateInvoice';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { printBarCodes, returnPurchase, updatePurchase } from '../../../../features/PurchaseSlice/PurchaseSlice';
import { toast } from 'react-toastify';
import usePaginationSearch from '../../../../hooks/usePaginationSearch';
import ReactPaginate from 'react-paginate';
import { GiReturnArrow } from "react-icons/gi";

const PurchaseList = () => {
    const { items, pageCount, limit, pageNo, loading, handleSearchResult,
        handleLimit, handlePageClick } = usePaginationSearch('https://servers.thakurgaonexpress.com/rupkotha/getpurchaseswithfilter')
    const userAc = useSelector((state) => state.user.user);
    const [purchaseModal, setPurchaseModal] = useState(null);
    const [updateModal, setUpdateModal] = useState(null);
    const dispatch = useDispatch();

    const handleAddProductToInvoice = (purchase) => {
        setPurchaseModal(purchase)


        const viewedUser = userAc?.email.split('@')[0]
        const currentUser = purchase?.user;

        if (viewedUser !== currentUser) {
            fetch(`https://servers.thakurgaonexpress.com/rupkotha/getpurchases/${purchase?._id}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ viewedUser }),
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                })
        }
    }
    const handleUpdatePurchase = (purchase) => {
        dispatch(updatePurchase(purchase));

    }

    const handleReturnPurchase = (purchase) => {
        dispatch(returnPurchase(purchase));

    }
    const handleDeleteProduct = (id) => {
        const proceed = window.confirm('Are You Sure Want To Delete')
        if (proceed) {
            fetch(`https://servers.thakurgaonexpress.com/rupkotha/getpurchases/${id}`, {
                method: 'DELETE'
            })
                .then(res => res.json())
                .then(data => {
                    toast.success('Delete Successful')
                    setTimeout(() => { window.location.reload(); }, 3000);
                })
        }
    };

    const handlePrintBarcode = (purchase) => {
        dispatch(printBarCodes(purchase?.products));
        console.log(purchase);
        
    }



    return (
        <div className='w-full px-4 pb-5 my-5'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Manage Purchases</h1>
            <div className='flex justify-between items-center my-4'>
                <div class="form-control w-28  max-w-xs lg:mr-2">
                    <label class="label">
                        <span class="label-text">Show</span>
                    </label>
                    <select onChange={handleLimit} defaultValue='' class="text-center text-xs rounded-lg text-textPrimary select select-bordered select-error w-full max-w-xs" required>
                        <option selected >20</option>
                        <option>10</option>
                        <option>50</option>
                        <option>100</option>
                        <option>All</option>
                    </select>
                </div>
                <div class="form-control w-60 mt-9">
                    <input onChange={handleSearchResult} type="text" placeholder="Search Purchase" class="input text-xs input-bordered bg-white input-error w-full max-w-xs" />
                </div>
            </div>
            <div className='overflow-auto'>
                <table class="table w-1/2 mx-auto text-xs">
                    <thead className='text-center'>
                        <tr>
                            <th className='bg-primary text-white normal-case'>SL#</th>
                            <th className='bg-primary text-white normal-case'>Purchase Date</th>
                            <th className='bg-primary text-white normal-case'>Invoice No</th>
                            <th className='bg-primary text-white normal-case'>Supplier</th>
                            <th className='bg-primary text-white normal-case'>Amount</th>
                            <th className='bg-primary text-white normal-case'>Payment</th>
                            <th className='bg-primary text-white normal-case'>Due</th>
                            <th className='bg-primary text-white normal-case'>Added</th>
                            {userAc.type === "Super Admin" && <th className='bg-primary text-white normal-case'>Reviewed</th>}
                            <th className='bg-primary text-white normal-case'>Print</th>
                            <th className='bg-primary text-white normal-case'>Purchase Return</th>
                            <th className='bg-primary text-white normal-case'>Action</th>
                            <th className='bg-primary text-white normal-case'>Action</th>
                        </tr>
                    </thead>
                    <tbody className='text-center'>
                        {
                            items?.map((purchase, index) => <tr className=''>
                                <td>{limit === "All" ? index + 1 : index + 1 + limit * (pageNo - 1)}</td>
                                <td>{purchase.purchaseDate}</td>
                                <td><label for="view-modal" onClick={() => handleAddProductToInvoice(purchase)} style={{ width: '150px', height: '50px' }} className={`text-blue-600 font-bold cursor-pointer`}>{purchase?.purchaseInvoice}</label></td>
                                <td>{purchase.purchaseSupplier}</td>
                                <td>{purchase.grandTotal}</td>
                                <td>{purchase.payment}</td>
                                <td>{purchase.dueAmount}</td>
                                <td><button className='btn btn-primary btn-xs normal-case text-white'>{purchase?.user ? purchase.user : "User"}</button></td>
                                {userAc.type === "Super Admin" && <td>{purchase?.viewedUser ? <button className='btn btn-xs btn-info normal-case text-white'>{purchase.viewedUser}</button> : <button className='btn btn-xs btn-warning normal-case text-white'>Not Viewed</button>}</td>}
                                <td><Link to='/printbarcode' onClick={() => handlePrintBarcode(purchase)} className='btn btn-primary btn-xs normal-case text-white'>Print Barcode</Link></td>
                                {userAc?.salesReturn && <td><Link to={purchase?.type ? `/returnpospurchase/edit/${purchase?._id}` : `/returnpurchase/edit/${purchase?._id}`} onClick={() => handleReturnPurchase(purchase)} className='btn btn-warning btn-xs'><GiReturnArrow /></Link></td>}
                                {userAc?.editPurchase && <td><Link to={purchase?.type ? `/managepospurchase/edit/${purchase._id}` : `/managepurchase/edit/${purchase._id}`} onClick={() => handleUpdatePurchase(purchase)} className='btn btn-info btn-xs'><FaEdit /></Link></td>}
                                {userAc?.deletePurchase && <td><button onClick={() => handleDeleteProduct(purchase._id)} className='text-xl text-danger'><AiFillDelete /></button></td>}
                            </tr>)
                        }


                    </tbody>
                </table>
            </div>
            {limit === "All" ? "" : <div className='my-8'>
                <ReactPaginate
                    previousLabel={'Pre'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={'btn-group justify-center'}
                    pageClassName={'btn btn-error text-white'}
                    activeClassName={'btn bg-white text-textPrimary'}
                    previousClassName={'btn btn-error text-white'}
                    nextClassName={'btn btn-error text-white'}
                    breakClassName={'btn btn-error text-white'}></ReactPaginate>
            </div>}

            <div className='w-8/12'>
                {
                    purchaseModal && <ViewInvoice setPurchaseModal={setPurchaseModal} purchaseModal={purchaseModal}></ViewInvoice>
                }
            </div>

            <div className='w-8/12'>
                {
                    updateModal && <UpdateInvoice setUpdateModal={setUpdateModal} updateModal={updateModal}></UpdateInvoice>
                }
            </div>

        </div>

    );
};

export default PurchaseList;